import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { IRootState } from './types';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';
import { reducers } from './reducers';

const initialState: IRootState = {
  sheets: [],
  searchedSheets: [],
  selectedMember: {} as IRootState['selectedMember'],
  selectedShift: {} as IRootState['selectedShift'],
  isOpenDeleteShiftDialog: false,
  isOpenEmployeesExportMode: false,
  selectedMembers: [] as unknown as IRootState['selectedMembers'],
  filteredSheets: [],
  selectedLocationId: 0,
};

export const slice = createSlice({
  name: STORE_SLICES.SHEETS,
  initialState,
  reducers,
});

const sheetsActions = slice.actions;

const sheetsPersistConfig = {
  key: PERSIST_KEYS.SHEETS,
  storage,
  whitelist: ['selectedMember'],
};

export {
  sheetsActions,
};

export default persistReducer(sheetsPersistConfig, slice.reducer);
